import React from 'react';
import { SearchIcon, MapIcon, BellIcon, MessageSquareIcon, Trash2Icon, CalendarDaysIcon, LayoutGridIcon, MegaphoneIcon, InboxIcon, TruckIcon, BarChart3Icon, CalendarIcon, ChevronDownIcon, SmartphoneIcon, MailIcon, PhoneIcon, ArrowUpIcon, MapPinIcon } from 'lucide-react';
import { phoneCopy, dashCopy, previewCopy, BROSSARD_PANORAMA, type Bi } from '../../../data/communicationsProof';
type P = {
  isFR: boolean;
};
const pk = (isFR: boolean) => (v: Bi) => isFR ? v.fr : v.en;
const SHORTCUT_ICONS: Record<string, typeof MapIcon> = {
  map: MapIcon,
  notices: BellIcon,
  requests: MessageSquareIcon,
  collect: Trash2Icon,
  calendar: CalendarDaysIcon
};
const NAV_ICONS: Record<string, typeof MapIcon> = {
  home: LayoutGridIcon,
  map: MapIcon,
  comms: MegaphoneIcon,
  requests: InboxIcon,
  collect: TruckIcon,
  analytics: BarChart3Icon
};
const CH_ICONS: Record<string, typeof MapIcon> = {
  push: SmartphoneIcon,
  sms: MessageSquareIcon,
  email: MailIcon,
  voice: PhoneIcon
};
function BrossardMark({
  light = false
}: {
  light?: boolean;
}) {
  return <span className={`flex items-center gap-1.5 font-sans font-semibold ${light ? 'text-white' : 'text-[#121212]'}`} data-id="element-2808" data-mp="3bjifji2c1ntn">
      <span className="grid grid-cols-2 gap-[2px]" aria-hidden="true" data-id="element-2809" data-mp="31rl2s6voenst">
        {[0, 1, 2, 3].map(i => <span key={i} className={`w-[5px] h-[5px] rounded-[1.5px] ${light ? 'bg-white' : 'bg-[#22A04F]'}`} data-id="element-2810" data-mp="36pwcmhlz0yb1" />)}
      </span>
      Brossard
    </span>;
}
export function CitizenPhone({
  isFR,
  showNotice = true
}: P & {
  showNotice?: boolean;
}) {
  const pick = pk(isFR);
  return <div className="relative w-[210px] rounded-[30px] bg-[#111320] p-[6px] shadow-[0_30px_60px_-24px_rgba(20,20,60,0.55)]" data-id="element-2811" data-mp="2isqmuukh7hb2">
      <div className="relative rounded-[25px] overflow-hidden bg-white" data-id="element-2812" data-mp="2nsl92ktb3ips">
        <div className="relative h-[168px]" data-id="element-2813" data-mp="h0kilplvpm6w">
          <img src={BROSSARD_PANORAMA} alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-2814" data-mp="h1n7xt3jzgkp" />
          <div className="absolute inset-0 bg-[#1B1D3A]/45" aria-hidden="true" data-id="element-2815" data-mp="lzfari5qkn3o" />
          <div className="absolute top-2 left-4 right-4 flex justify-between font-sans text-[8.5px] text-white/90" aria-hidden="true" data-id="element-2816" data-mp="jmbf5hd8ylio">
            <span data-id="element-2817" data-mp="fmb323dmemes">9:41</span>
            <span className="w-14 h-4 rounded-full bg-[#111320] -mt-0.5" data-id="element-2818" data-mp="akby4p28fhfq" />
            <span data-id="element-2819" data-mp="amoo9pi58y3v">{isFR ? '100 %' : '100%'}</span>
          </div>
          <div className="absolute left-3 top-9 text-[15px]" data-id="element-2820" data-mp="5nbrod1h0co3">
            <BrossardMark light data-id="element-2821" data-mp="13a0zx4mrnlie" />
          </div>
          <div className="absolute left-3 right-3 bottom-3 rounded-full bg-white px-3 py-1.5 flex items-center gap-1.5" data-id="element-2822" data-mp="138pvr3pesbqr">
            <SearchIcon className="w-3 h-3 text-[#6B7180]" aria-hidden="true" data-id="element-2823" data-mp="tjpx5letjid3" />
            <span className="font-sans text-[9px] text-[#6B7180]" data-id="element-2824" data-mp="thmwm7g1i6u4">{pick(phoneCopy.search)}</span>
          </div>
        </div>

        <div className="px-3 pt-3 pb-4" data-id="element-2825" data-mp="1m00ozrilx0lt">
          {showNotice && <div className="rounded-xl border border-[#EEEEF4] px-2.5 py-2 mb-3 shadow-[0_6px_14px_-10px_rgba(20,20,60,0.35)]" data-id="element-2826" data-mp="1m23m0vi6fu01">
              <p className="flex items-center justify-between font-sans text-[7.5px] text-[#6B7180]" data-id="element-2827" data-mp="1okou9a8qpvh5">
                <BrossardMark data-id="element-2828" data-mp="1tj9u38k2yd52" />
                {pick(previewCopy.notifNow)}
              </p>
              <p className="font-sans text-[9px] font-semibold text-[#121212] mt-1" data-id="element-2829" data-mp="1yimku4e2o4cx">{pick(previewCopy.notifTitle)}</p>
              <p className="font-sans text-[8.5px] text-[#3A4050] leading-snug" data-id="element-2830" data-mp="23i8xocpznil7">{pick(previewCopy.notifBody)}</p>
            </div>}
          <ul className="grid grid-cols-3 gap-2" data-id="element-2831" data-mp="27j14kzbe1beb">
            {phoneCopy.shortcuts.map(s => {
            const Icon = SHORTCUT_ICONS[s.key];
            return <li key={s.key} className="rounded-xl border border-[#EEEEF4] py-2 flex flex-col items-center gap-1" data-id="element-2832" data-mp="2ha5kq2csv2aq">
                  <span className="w-7 h-7 rounded-lg bg-[#F1F0FD] flex items-center justify-center" aria-hidden="true" data-id="element-2833" data-mp="2m7nwe0i7bvmf">
                    <Icon className="w-3.5 h-3.5 text-[#4F46E5]" strokeWidth={1.8} data-id="element-2834" data-mp="2r57an0ewg8ed" />
                  </span>
                  <span className="font-sans text-[8px] text-[#121212]" data-id="element-2835" data-mp="2v6iz32m1enkz">{pick(s.label)}</span>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </div>;
}
export function BrossardDashboard({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="rounded-[18px] bg-[#1A1C2E] p-[7px] shadow-[0_30px_70px_-34px_rgba(20,20,60,0.6)]" data-id="element-2836" data-mp="5jwgkde7e7lm">
      <div className="rounded-xl overflow-hidden bg-white flex" data-id="element-2837" data-mp="1l720hhfik0e">
        <nav className="hidden sm:flex w-[120px] shrink-0 border-r border-[#EEEEF4] px-2 py-3 flex-col gap-0.5" aria-label={isFR ? 'Navigation de l’application' : 'App navigation'} data-id="element-2838" data-mp="39zp504sij9d5">
          <span className="px-1.5 pb-3 text-[12px]" data-id="element-2839" data-mp="3izubmcpvu3q9">
            <BrossardMark data-id="element-2840" data-mp="3ix7tjj5d85ts" />
          </span>
          {dashCopy.nav.map(n => {
          const Icon = NAV_ICONS[n.key];
          const active = n.key === 'comms';
          return <span key={n.key} className={`flex items-center gap-1.5 rounded-md px-1.5 py-1.5 font-sans text-[9px] ${active ? 'bg-[#141629] text-white' : 'text-[#3A4050]'}`} data-id="element-2841" data-mp="ybg0y0mjdrp7">
                <Icon className={`w-3 h-3 ${active ? 'text-[#A99CF9]' : 'text-[#9AA0AE]'}`} aria-hidden="true" data-id="element-2842" data-mp="11ppouij946o6" />
                {pick(n.label)}
              </span>;
        })}
        </nav>
        <div className="flex-1 min-w-0 p-3" data-id="element-2843" data-mp="ruo19r4mjcnp">
          <div className="flex items-start justify-between gap-2" data-id="element-2844" data-mp="wrxwjnep2ijg">
            <div data-id="element-2845" data-mp="wuac5twzcgtc">
              <p className="font-sans text-[13px] font-semibold text-[#121212]" data-id="element-2846" data-mp="1khs9e4z0k73p">Communications</p>
              <p className="font-sans text-[9px] text-[#6B7180] mt-0.5" data-id="element-2847" data-mp="1pgvflsqqcjd9">{pick(dashCopy.overview)}</p>
            </div>
            <span className="inline-flex items-center gap-1 rounded-md border border-[#E6E7EE] px-2 py-1 font-sans text-[8.5px] text-[#3A4050] whitespace-nowrap" data-id="element-2848" data-mp="1as8s33qy8lay">
              <CalendarIcon className="w-2.5 h-2.5" aria-hidden="true" data-id="element-2849" data-mp="1foz2pbjziooz" />
              {pick(dashCopy.period)}
              <ChevronDownIcon className="w-2.5 h-2.5" aria-hidden="true" data-id="element-2850" data-mp="23etf5s0e6b8p" />
            </span>
          </div>
          <div className="mt-2.5 grid grid-cols-3 gap-1.5" data-id="element-2851" data-mp="2i3bjr4plz0kz">
            {dashCopy.kpis.map(k => <div key={k.label.fr} className="rounded-lg border border-[#EEEEF4] px-2 py-1.5 min-w-0" data-id="element-2852" data-mp="2d4i71ei5bdlv">
                <p className="font-sans text-[7.5px] text-[#6B7180] truncate" data-id="element-2853" data-mp="284vul7a561e4">{pick(k.label)}</p>
                <p className="flex items-center gap-1 mt-1" data-id="element-2854" data-mp="243u35cmgutmp">
                  <span className="font-sans text-[13px] font-semibold text-[#121212] tabular-nums whitespace-nowrap" data-id="element-2855" data-mp="243ank2kaghbu">{pick(k.value)}</span>
                  {k.trend && <span className="inline-flex items-center rounded bg-[#EAF7EE] px-1 font-sans text-[7px] text-[#1E8A45] whitespace-nowrap" data-id="element-2856" data-mp="1ucz5zd7om9mh">
                      <ArrowUpIcon className="w-2 h-2" aria-hidden="true" data-id="element-2857" data-mp="1pcbj93qhkey2" />
                      {isFR ? k.trend : k.trend.replace(' %', '%')}
                    </span>}
                </p>
              </div>)}
          </div>
          <div className="mt-2 grid grid-cols-[1.1fr_1fr] gap-1.5" data-id="element-2858" data-mp="1bg7nv73vm0k0">
            <div className="rounded-lg border border-[#EEEEF4] px-2 py-2 min-w-0" data-id="element-2859" data-mp="3n2rrb9y2ol1h">
              <p className="font-sans text-[9px] font-semibold text-[#121212]" data-id="element-2860" data-mp="3s12z7f4t4lh2">{pick(dashCopy.channelsTitle)}</p>
              <ul className="mt-1.5 space-y-1.5" data-id="element-2861" data-mp="3w2etvz2jfww4">
                {dashCopy.channels.map(c => {
                const Icon = CH_ICONS[c.key];
                return <li key={c.key} className="flex items-center gap-1.5 font-sans text-[7.5px] text-[#121212]" data-id="element-2862" data-mp="34bqtip8ouvji">
                      <Icon className="w-2.5 h-2.5 text-[#4F46E5] shrink-0" aria-hidden="true" data-id="element-2863" data-mp="38d2jwwzdzksr" />
                      <span className="w-12 truncate" data-id="element-2864" data-mp="3dcox56f7t11k">{pick(c.label)}</span>
                      <span className="w-9 tabular-nums text-[#6B7180]" data-id="element-2865" data-mp="3dalzq1bqg5mt">{pick(c.sent)}</span>
                      <span className="flex-1 h-1 rounded-full bg-[#EEEFF4] overflow-hidden" aria-hidden="true" data-id="element-2866" data-mp="3i58d2a1dk89j">
                        <span className="block h-full bg-[#4F46E5]" style={{
                      width: `${c.open}%`
                    }} data-id="element-2867" data-mp="2pmun0wma5ql0" />
                      </span>
                    </li>;
              })}
              </ul>
            </div>
            <div className="rounded-lg border border-[#EEEEF4] px-2 py-2 min-w-0 flex flex-col" data-id="element-2868" data-mp="1e0yssgscgpw3">
              <p className="font-sans text-[9px] font-semibold text-[#121212] truncate" data-id="element-2869" data-mp="1s0q60fb1e291">{pick(dashCopy.coverageTitle)}</p>
              <div className="relative mt-1.5 flex-1 min-h-[70px] rounded-md overflow-hidden bg-[#F2F3F1]" data-id="element-2870" data-mp="1nxk41juyix8d">
                <svg viewBox="0 0 120 80" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full" aria-hidden="true" data-id="element-2871" data-mp="21x35jtt9jabp">
                  <g stroke="#FFFFFF" strokeWidth="1" data-id="element-2872" data-mp="2bo7lowuod184">
                    {Array.from({
                    length: 10
                  }).map((_, i) => <line key={i} x1={i * 14} y1="0" x2={i * 14 - 8} y2="80" data-id="element-2873" data-mp="26okzhxwvcan6" data-mpi={i} />)}
                    {Array.from({
                    length: 7
                  }).map((_, i) => <line key={`h${i}`} x1="0" y1={i * 13} x2="120" y2={i * 13 + 4} data-id="element-2874" data-mp="2kmj8sowc1gvt" data-mpi={i} />)}
                  </g>
                  <path d="M14 18 L52 8 L72 26 L66 66 L28 74 L10 50 Z" fill="#6D5DF6" fillOpacity="0.32" stroke="#5B4BE0" strokeWidth="0.8" data-id="element-2875" data-mp="2zb2wqf12e4b1" />
                </svg>
                <div className="absolute right-1 bottom-1 rounded bg-white px-1.5 py-1 shadow-sm" data-id="element-2876" data-mp="348beieiaw6br">
                  <p className="flex items-center gap-1 font-sans text-[7px] font-semibold text-[#121212]" data-id="element-2877" data-mp="2qd8yuznnj2lr">
                    <MapPinIcon className="w-2 h-2 text-[#4F46E5]" aria-hidden="true" data-id="element-2878" data-mp="2gl38fud1st8o" />
                    {pick(dashCopy.district.name)}
                  </p>
                  {dashCopy.district.lines.map(l => <p key={l.fr} className="font-sans text-[6.5px] text-[#5B6478] whitespace-nowrap" data-id="element-2879" data-mp="26nfe35jctnr1">
                      {pick(l)}
                    </p>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}